<template>
  <v-container
    v-if="templates.length > 0"
    grid-list-md
    justify-start
    fluid
    class="pl-0 pr-6 mb-4"
  >
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          :placeholder="$t('project.search-label')"
          append-icon="mdi-magnify"
          hide-details="auto"
          dense
          solo
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-chip
          v-for="(theme, index) of filters"
          :key="index"
          :input-value="theme.active"
          filter-icon="mdi-label"
          filter
          :ripple="true"
          :color="theme.color"
          class="mx-1"
          @click="filterTheme(index)"
        >
          {{ theme.label }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-flex
        v-for="(template, index) in searchedTemplates"
        :key="index"
        class="pa-1"
        xs12
        sm6
        md4
        lg2
        xl2
      >
        <template-card
          :deletable="template.shared == 0"
          :card-data="template"
          @refresh="refresh"
        >
          {{ template.name }}
        </template-card>
      </v-flex>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { TemplateConnector } from "../Database/TemplateConnector";

// Components
import templateCard from "../Common/TemplateCard";

// Tools
const pathInfo = require("path");
const accents = require("remove-accents");

export default {
  components: {
    templateCard,
  },
  data() {
    return {
      templateConnector: new TemplateConnector(this.$store.state.user),
      filters: [],
      filtersActive: [],
      search: "",
      templates: [],
    };
  },
  computed: {
    filteredTemplates() {
      let result = this.templates;

      if (this.filtersActive.length > 0) {
        result = this.templates.filter((template) => {
          let found = false;

          for (const filter of this.filtersActive) {
            found = false;

            for (const theme of template.theme.split(";")) {
              if (filter == theme) {
                found = true;
              }
            }

            if (!found) {
              return false;
            }
          }
          return found;
        });
      }

      return result;
    },
    searchedTemplates() {
      let result = this.filteredTemplates;

      if (this.search.length > 0) {
        result = this.filteredTemplates.filter((template) => {
          return accents.remove(template.name.toLowerCase()).includes(accents.remove(this.search.toLowerCase()));
        });
      }

      return result;
    },
  },
  created() {
    // Init filters
    this.createFilterList();
    this.refresh();
  },
  methods: {
    createFilterList() {
      for (const theme in this.$t("project.theme")) {
        this.filters.push({
          label: this.$t("project.theme")[theme],
          value: theme,
          active: false,
          color: "",
        });
      }
    },
    filterTheme(index) {
      const selectedFilter = this.filters[index];
      selectedFilter.active = !selectedFilter.active;

      if (selectedFilter.active) {
        this.filtersActive.push(selectedFilter.value);
        selectedFilter.color = "primary";
      } else {
        this.filtersActive.splice(this.filtersActive.indexOf(selectedFilter.value), 1);
        selectedFilter.color = "";
      }
    },
    refresh() {
      // Retrieve all shared templates
      this.templateConnector
        .getTemplate()
        .then((response) => {
          this.templates = response.map((value) => {
            const name = pathInfo.basename(value.path, ".zip");
            return {
              id: value.id_temp,
              name: name,
              width: value.width,
              height: value.height,
              path: value.path,
              theme: value.theme,
              shared: value.shared,
              isTemplate: true,
            };
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
